(() => {
  const dialog = document.querySelector('.ll-page-preview');
  if (!dialog) return;
  const image = dialog.querySelector('img');
  let trigger;
  let lockedBefore = false;
  const track = (name, data) => {
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) {
      window.Shopify.analytics?.publish?.(name, {
        ...data, page_location: window.location.pathname,
        device_category: window.innerWidth < 750 ? 'mobile' : 'desktop',
      });
    }
  };
  document.addEventListener('click', (event) => {
    const preview = event.target.closest('[data-preview-src]');
    if (preview) {
      trigger = preview;
      image.src = preview.dataset.previewSrc;
      image.alt = preview.dataset.previewAlt;
      lockedBefore = document.body.classList.contains('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      dialog.showModal();
      track('book_preview_open', { product_id: preview.dataset.productId });
    }
    const link = event.target.closest('[data-studio-event]');
    if (link) track(link.dataset.studioEvent, { product_id: link.dataset.productId, sample_id: link.dataset.sampleId });
  });
  dialog.querySelector('button').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    if (!lockedBefore) document.body.classList.remove('overflow-hidden');
    trigger?.focus({ preventScroll: true });
  });
})();
